export const tableData = [
    {
        img:"1.png",
        name:"Long Top",
        class:"order-process-circle",
        status:"Processing",
        size:"M",
        color:"Lavander",
        number:"4215738",
        units:"1",
        price:"$21"
    },
    {
        img:"13.png",
        name:"Fancy watch",
        class:"order-process-circle",
        status:"Processing",
        size:"35mm",
        color:"Blue",
        number:"5476182",
        units:"1",
        price:"$10"
    },
    {
        img:"4.png",
        name:"Man shoes",
        class:"order-process-circle",
        status:"Processing",
        size:"8",
        color:"Black & white",
        number:"1756457",
        units:"1",
        price:"$18"
    },
    {
        img:"10.png",
        name:"Ledis side bag",
        class:"order-process-circle shipped-order",
        status:"Shipped",
        size:"22cm x 18cm",
        color:"Brown",
        number:"7451725",
        units:"1",
        price:"$13"
    },
    {
        img:"12.png",
        name:"Ledis Slipper",
        class:"order-process-circle shipped-order",
        status:"Shipped",
        size:"6",
        color:"Brown & white",
        number:"4127421",
        units:"1",
        price:"$6"
    },
    {
        img:"3.png",
        name:"Fancy ledis Jacket",
        class:"order-process-circle shipped-order",
        status:"Shipped",
        size:"Xl",
        color:"Light gray",
        number:"3581714",
        units:"1",
        price:"$24"
    },
    {
        img:"2.png",
        name:"Ledis Handbag",
        class:"order-process-circle shipped-order",
        status:"Shipped",
        size:"25cm x 20cm",
        color:"Black",
        number:"6748142",
        units:"1",
        price:"$14"
    },
    {
        img:"15.png",
        name:"Iphone6 mobile",
        class:"order-process-circle cancel-order",
        status:"Cancelled",
        size:"10cm x 15cm",
        color:"Black",
        number:"5748214",
        units:"1",
        price:"$25"
    },
    {
        img:"14.png",
        name:"Watch",
        class:"order-process-circle cancel-order",
        status:"Cancelled",
        size:"27mm",
        color:"Brown",
        number:"2471254",
        units:"1",
        price:"$12"
    },
    {
        img:"11.png",
        name:"Slipper",
        class:"order-process-circle cancel-order",
        status:"Cancelled",
        size:"6",
        color:"Blue",
        number:"8475112",
        units:"1",
        price:"$6"
    }
    
]